import React from 'react'

export default ({
  loading,
  children
}) => {
  if (loading) {
    return <p>Loading...</p>
  } else {
    return children()
  }
}



// WEBPACK FOOTER //
// ./src/components/pins/pin-loading-indicator.js